import { render, staticRenderFns } from "./WeeklyTimeSettingsTab.vue?vue&type=template&id=34578363&scoped=true"
import script from "./WeeklyTimeSettingsTab.vue?vue&type=script&lang=js"
export * from "./WeeklyTimeSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTimeSettingsTab.vue?vue&type=style&index=0&id=34578363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34578363",
  null
  
)

export default component.exports